import { render, staticRenderFns } from "./productionCapacities.vue?vue&type=template&id=7a79df08&"
import script from "./productionCapacities.vue?vue&type=script&lang=js&"
export * from "./productionCapacities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports